import {
    checkShareGuide,
    firstShareGuide,
    shareForCoin
} from '../../../api/wz/share'

import {assign, getServerTime, dataFormat } from '../../../utils/base'
import { update } from '../../../utils/vuex'

const state = {
    
}
export default {
    namespaced: true,
    state,    
    getters: {
        
    },

    actions: {
        async loadCheckShareGuide ({commit}, query){
            const R = await checkShareGuide(query)
            return R 
        },
        async loadFirstShareGuide ({commit}, query){
            const R = await firstShareGuide(query)            
            return R 
        },
        async loadShareForCoin ({commit}, query){
            const R = await shareForCoin(query)
            return R 
        }
    },

    mutations: {
        update,
    }
}